import { apiFetch } from './api.js';

/**
 * Prompt-to-transaction for App 1's log entry and App 3's finding (pass 8).
 * App 2's lesson draft has its own helpers in `lesson-api.ts`, because a
 * lesson's id is made on the device.
 */

export interface FormPromptDraft {
  suggestionId: string | null;
  fields: Record<string, string>;
  clarifications: { field: string; question: string; options?: { value: string; label: string }[] }[];
  /** Figures the sentence did not give, left for the person to enter. */
  notStated: string[];
  timedOut: boolean;
  unavailableReason: string | null;
}

export type FormPromptDisposition = 'accepted' | 'edited' | 'rejected';

export const requestLogEntryDraft = (prompt: string) =>
  apiFetch<FormPromptDraft>('/qaqc/ai/prompt-drafts', { method: 'POST', body: JSON.stringify({ prompt }) });

export const requestFindingDraft = (auditId: string, prompt: string) =>
  apiFetch<FormPromptDraft>(`/audit/audits/${auditId}/ai/finding-draft`, {
    method: 'POST',
    body: JSON.stringify({ prompt }),
  });

/**
 * What became of a draft. The server judges it from `recordId`, the record the
 * person saved; the claim is only what the screen believes.
 */
export const disposeFormDraft = (
  app: 'qaqc' | 'audit',
  suggestionId: string,
  body: { claimed: FormPromptDisposition; recordId?: string | null; answers?: Record<string, string> },
) =>
  apiFetch<{ disposition: FormPromptDisposition }>(`/${app}/ai/prompt-drafts/${suggestionId}/disposition`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
